const firebaseConfig = {
    apiKey: "AIzaSyDtwrUm0oBEEOs_nW4gzl-TiYRtWBiIm8w",
    authDomain: "travel-guru-8664d.firebaseapp.com",
    databaseURL: "https://travel-guru-8664d.firebaseio.com",
    projectId: "travel-guru-8664d",
    storageBucket: "travel-guru-8664d.appspot.com",
    messagingSenderId: "851646829228",
    appId: "1:851646829228:web:57d0c2857d420357434509"
  };
  export default firebaseConfig;